import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgImpactDrkBluFullcolorIcon = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	id: "Impact_Layer_1",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	viewBox: "0 0 432.84 98.29",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsxs("defs", { children: [
		/* @__PURE__ */ _jsx("style", { children: "\n.impact-cls-1{stroke:#f6921e;}\n.impact-cls-1,.impact-cls-2,.impact-cls-3,.impact-cls-4,.impact-cls-5,.impact-cls-6,.impact-cls-7,.impact-cls-8,.impact-cls-9,.impact-cls-10,.impact-cls-11,.impact-cls-12,.impact-cls-13,.impact-cls-14,.impact-cls-15,.impact-cls-16,.impact-cls-17{fill:none;}\n.impact-cls-1,.impact-cls-10,.impact-cls-11,.impact-cls-15{stroke-width:2.59px;}\n.impact-cls-2,.impact-cls-5,.impact-cls-13,.impact-cls-14{stroke-width:1.72px;}\n.impact-cls-2,.impact-cls-7{stroke:#0cc;}\n.impact-cls-3{stroke:#f93;}\n.impact-cls-3,.impact-cls-4,.impact-cls-6,.impact-cls-12{stroke-width:.86px;}\n.impact-cls-4,.impact-cls-10{stroke:#f33;}\n.impact-cls-18{clip-path:url(#impact-clippath-2);}\n.impact-cls-5,.impact-cls-9{stroke:#3a6bb3;}\n.impact-cls-19{clip-path:url(#impact-clippath-1);}\n.impact-cls-20{fill:#036;}\n.impact-cls-6,.impact-cls-11{stroke:#c33;}\n.impact-cls-7,.impact-cls-9,.impact-cls-16,.impact-cls-17{stroke-width:4.31px;}\n.impact-cls-21{clip-path:url(#impact-clippath);}\n.impact-cls-22{clip-path:url(#impact-clippath-3);}\n.impact-cls-12{stroke:#faaf40;}\n.impact-cls-13,.impact-cls-17{stroke:#369;}\n.impact-cls-14,.impact-cls-16{stroke:#6cc;}\n.impact-cls-15{stroke:#fbb03b;}\n" }),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "impact-clippath",
			children: /* @__PURE__ */ _jsx("polygon", {
				className: "impact-cls-8",
				points: "384.23 50.34 432.84 47.73 424.45 81.92 394.19 103.82 353.16 99.36 344.05 86.99 346.27 83.29 348.22 81.94 354.75 76.01 356.41 74.95 362.81 68.87 364.38 67.42 370.07 62.52 372.3 60.1 376.42 57.59 372.14 50.66 325.63 62.8 324.18 33.73 338.41 8.74 368.01 -2.89 396.14 -3.62 426.28 12.57 415.95 21.24 413.45 22.82 407.61 27.85 405.58 29.12 399.21 34.34 397.84 35.3 392.23 40.13 390.63 41.07 389.13 41.94 385.26 45.36 384.23 50.34"
			})
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "impact-clippath-1",
			children: /* @__PURE__ */ _jsx("polygon", {
				id: "impact-small",
				className: "impact-cls-8",
				points: "378.42 50.8 392.81 47.84 396.47 46.54 401.89 44.73 405.75 43.27 412.74 41.91 415.42 40.59 422.81 39.02 425.63 37.61 431.68 40.1 429.77 84.15 388.7 102.43 368.05 99.82 378.65 58.52 373.68 51.36 368.72 53.87 365.44 55.52 359.32 58.12 356.82 59.59 350.09 62.46 346.98 64.24 339.97 67.22 337.33 68.73 328.42 72.66 325.44 33.96 339.68 8.98 369.28 -2.65 399.07 1.13 378.42 50.8"
			})
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "impact-clippath-2",
			children: /* @__PURE__ */ _jsx("polygon", {
				id: "impact-Med-2",
				className: "impact-cls-8",
				points: "380.23 49.54 384.23 54.48 423.86 76.99 414.19 92.2 388.51 104.92 361.35 98.24 361.12 88.65 367.89 88.65 367.75 76.68 374.16 76.68 374.37 68.52 376.29 66.22 376.33 58.34 375.49 46.06 333.82 22.1 341.23 5.96 370.84 -5.66 412.47 -.97 407.53 6.76 405.05 9.82 401.1 16.84 398.72 19.94 394.6 26.68 391 31.52 389.75 33.58 386 38.43 380.23 49.54"
			})
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "impact-clippath-3",
			children: /* @__PURE__ */ _jsx("polygon", {
				id: "impact-Thick-2",
				className: "impact-cls-8",
				points: "379.95 46.34 389.65 51.03 396.33 54.37 399.61 54.78 405.32 57.51 410.12 58.48 415.91 61.2 420.16 61.99 425.72 64.62 437.72 68.8 416.98 94.06 382.05 102.29 381.81 90.64 381.75 87.5 381.77 79.86 381.52 75.78 381.59 68.49 381.33 66.22 381.35 59.1 381.07 53.45 374.47 49.13 368.55 49.25 361.92 48.77 357.8 49.16 351.07 48.72 345.49 48.99 338.51 48.51 333.11 48.71 327.04 48.31 317.72 48.15 341.32 5.96 379.95 -7.52 379.95 46.34"
			})
		})
	] }), /* @__PURE__ */ _jsxs("g", {
		id: "Impact_Rect-Name_logo",
		children: [/* @__PURE__ */ _jsxs("g", { children: [
			/* @__PURE__ */ _jsx("path", {
				className: "impact-cls-20",
				d: "M9.19,13.76h6.79V81.72h-6.79V13.76Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "impact-cls-20",
				d: "M27.65,81.72L37.38,13.76h1.1l27.63,55.77L93.48,13.76h1.09l9.78,67.97h-6.66l-6.71-48.61-24.03,48.61h-1.74l-24.32-48.98-6.68,48.98h-6.56Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "impact-cls-20",
				d: "M116.28,13.76h13.54c7.76,0,13,.34,15.71,1.02,3.88,.96,7.05,2.92,9.52,5.89,2.46,2.97,3.7,6.71,3.7,11.2s-1.2,8.26-3.6,11.2c-2.4,2.94-5.71,4.92-9.93,5.94-3.08,.74-8.84,1.11-17.28,1.11h-4.85v31.6h-6.79V13.76Zm6.79,6.65v23.06l11.51,.14c4.65,0,8.05-.42,10.21-1.27,2.16-.85,3.85-2.21,5.08-4.1,1.23-1.89,1.85-4,1.85-6.34s-.62-4.36-1.85-6.25c-1.23-1.89-2.86-3.24-4.88-4.04-2.02-.8-5.32-1.2-9.91-1.2h-12.01Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "impact-cls-20",
				d: "M188.95,13.76l31.7,67.97h-7.34l-10.69-22.36h-29.28l-10.59,22.36h-7.58L187.29,13.76h1.66Zm-.86,14.44l-11.65,24.6h23.24l-11.59-24.6Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "impact-cls-20",
				d: "M288.16,26.37l-5.36,4.11c-2.96-3.85-6.51-6.77-10.65-8.76-4.14-1.99-8.7-2.98-13.65-2.98-5.42,0-10.44,1.3-15.06,3.9-4.62,2.6-8.2,6.1-10.74,10.49-2.54,4.39-3.81,9.33-3.81,14.81,0,8.29,2.84,15.2,8.52,20.75,5.68,5.54,12.85,8.32,21.51,8.32,9.52,0,17.48-3.73,23.89-11.18l5.36,4.07c-3.39,4.31-7.62,7.65-12.68,10-5.07,2.36-10.73,3.53-16.98,3.53-11.89,0-21.27-3.96-28.14-11.87-5.76-6.68-8.64-14.75-8.64-24.21,0-9.95,3.49-18.32,10.46-25.11s15.72-10.19,26.22-10.19c6.34,0,12.07,1.26,17.19,3.77,5.11,2.51,9.3,6.03,12.57,10.56Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "impact-cls-20",
				d: "M293.09,20.41v-6.65h37.24v6.65h-15.15v61.31h-6.93V20.41h-15.16Z"
			})
		] }), /* @__PURE__ */ _jsxs("g", { children: [
			/* @__PURE__ */ _jsx("g", {
				id: "Impact_Tny",
				children: /* @__PURE__ */ _jsx("g", {
					className: "impact-cls-21",
					children: /* @__PURE__ */ _jsxs("g", { children: [
						/* @__PURE__ */ _jsx("path", {
							className: "impact-cls-12",
							d: "M397.45,4.89h-36.23c-4.67,0-8.98,2.49-11.31,6.53l-18.12,31.38c-2.33,4.04-2.33,9.02,0,13.07l18.12,31.38c2.33,4.04,6.65,6.53,11.31,6.53h36.23c4.67,0,8.98-2.49,11.31-6.53l18.12-31.38c2.33-4.04,2.33-9.02,0-13.07l-18.12-31.38c-2.33-4.04-6.65-6.53-11.31-6.53Z"
						}),
						/* @__PURE__ */ _jsx("path", {
							className: "impact-cls-3",
							d: "M391.52,15.49h-23.99c-4.67,0-8.98,2.49-11.31,6.53l-12,20.78c-2.33,4.04-2.33,9.02,0,13.07l12,20.78c2.33,4.04,6.65,6.53,11.31,6.53h23.99c4.67,0,8.98-2.49,11.31-6.53l12-20.78c2.33-4.04,2.33-9.02,0-13.07l-12-20.78c-2.33-4.04-6.65-6.53-11.31-6.53Z"
						}),
						/* @__PURE__ */ _jsx("path", {
							className: "impact-cls-4",
							d: "M385.52,25.51h-11.99c-4.67,0-8.98,2.49-11.31,6.53l-6,10.39c-2.33,4.04-2.33,9.02,0,13.07l6,10.39c2.33,4.04,6.65,6.53,11.31,6.53h11.99c4.67,0,8.98-2.49,11.31-6.53l6-10.39c2.33-4.04,2.33-9.02,0-13.07l-6-10.39c-2.33-4.04-6.65-6.53-11.31-6.53Z"
						}),
						/* @__PURE__ */ _jsx("path", {
							className: "impact-cls-6",
							d: "M384.68,35.88h-10.22c-1.51,0-2.91,.81-3.66,2.11l-5.11,8.85c-.76,1.31-.76,2.92,0,4.23l5.11,8.85c.76,1.31,2.15,2.11,3.66,2.11h10.22c1.51,0,2.91-.81,3.66-2.11l5.11-8.85c.76-1.31,.76-2.92,0-4.23l-5.11-8.85c-.76-1.31-2.15-2.11-3.66-2.11Z"
						})
					] })
				})
			}),
			/* @__PURE__ */ _jsx("g", {
				id: "Impact_Sml",
				children: /* @__PURE__ */ _jsx("g", {
					className: "impact-cls-19",
					children: /* @__PURE__ */ _jsxs("g", { children: [
						/* @__PURE__ */ _jsx("path", {
							className: "impact-cls-13",
							d: "M397.59,5.03h-36.23c-4.67,0-8.98,2.49-11.31,6.53l-18.12,31.38c-2.33,4.04-2.33,9.02,0,13.07l18.12,31.38c2.33,4.04,6.65,6.53,11.31,6.53h36.23c4.67,0,8.98-2.49,11.31-6.53l18.12-31.38c2.33-4.04,2.33-9.02,0-13.07l-18.12-31.38c-2.33-4.04-6.65-6.53-11.31-6.53Z"
						}),
						/* @__PURE__ */ _jsx("path", {
							className: "impact-cls-5",
							d: "M391.8,15.39h-24.27c-4.67,0-8.98,2.49-11.31,6.53l-12.14,21.02c-2.33,4.04-2.33,9.02,0,13.07l12.14,21.02c2.33,4.04,6.65,6.53,11.31,6.53h24.27c4.67,0,8.98-2.49,11.31-6.53l12.14-21.02c2.33-4.04,2.33-9.02,0-13.07l-12.14-21.02c-2.33-4.04-6.65-6.53-11.31-6.53Z"
						}),
						/* @__PURE__ */ _jsx("path", {
							className: "impact-cls-2",
							d: "M385.8,25.41h-12.28c-4.67,0-8.98,2.49-11.31,6.53l-6.14,10.63c-2.33,4.04-2.33,9.02,0,13.07l6.14,10.63c2.33,4.04,6.65,6.53,11.31,6.53h12.28c4.67,0,8.98-2.49,11.31-6.53l6.14-10.63c2.33-4.04,2.33-9.02,0-13.07l-6.14-10.63c-2.33-4.04-6.65-6.53-11.31-6.53Z"
						}),
						/* @__PURE__ */ _jsx("path", {
							className: "impact-cls-14",
							d: "M384.93,35.84h-10.43c-1.51,0-2.91,.81-3.66,2.11l-5.22,9.04c-.76,1.31-.76,2.92,0,4.23l5.22,9.04c.76,1.31,2.15,2.11,3.66,2.11h10.43c1.51,0,2.91-.81,3.66-2.11l5.22-9.04c.76-1.31,.76-2.92,0-4.23l-5.22-9.04c-.76-1.31-2.15-2.11-3.66-2.11Z"
						})
					] })
				})
			}),
			/* @__PURE__ */ _jsx("g", {
				id: "Impact_Med",
				children: /* @__PURE__ */ _jsx("g", {
					className: "impact-cls-18",
					children: /* @__PURE__ */ _jsxs("g", { children: [
						/* @__PURE__ */ _jsx("path", {
							className: "impact-cls-15",
							d: "M397.42,4.89h-36.23c-4.67,0-8.98,2.49-11.31,6.53l-18.12,31.38c-2.33,4.04-2.33,9.02,0,13.07l18.12,31.38c2.33,4.04,6.65,6.53,11.31,6.53h36.23c4.67,0,8.98-2.49,11.31-6.53l18.12-31.38c2.33-4.04,2.33-9.02,0-13.07l-18.12-31.38c-2.33-4.04-6.65-6.53-11.31-6.53Z"
						}),
						/* @__PURE__ */ _jsx("path", {
							className: "impact-cls-1",
							d: "M391.5,15.46h-24.03c-4.67,0-8.98,2.49-11.31,6.53l-12.01,20.81c-2.33,4.04-2.33,9.02,0,13.07l12.01,20.81c2.33,4.04,6.65,6.53,11.31,6.53h24.03c4.67,0,8.98-2.49,11.31-6.53l12.01-20.81c2.33-4.04,2.33-9.02,0-13.07l-12.01-20.81c-2.33-4.04-6.65-6.53-11.31-6.53Z"
						}),
						/* @__PURE__ */ _jsx("path", {
							className: "impact-cls-10",
							d: "M385.44,25.6h-11.89c-4.67,0-8.98,2.49-11.31,6.53l-5.95,10.3c-2.33,4.04-2.33,9.02,0,13.07l5.95,10.3c2.33,4.04,6.65,6.53,11.31,6.53h11.89c4.67,0,8.98-2.49,11.31-6.53l5.95-10.3c2.33-4.04,2.33-9.02,0-13.07l-5.95-10.3c-2.33-4.04-6.65-6.53-11.31-6.53Z"
						}),
						/* @__PURE__ */ _jsx("path", {
							className: "impact-cls-11",
							d: "M384.67,35.85h-10.26c-1.51,0-2.91,.81-3.66,2.11l-5.13,8.88c-.76,1.31-.76,2.92,0,4.23l5.13,8.88c.76,1.31,2.15,2.11,3.66,2.11h10.26c1.51,0,2.91-.81,3.66-2.11l5.13-8.88c.76-1.31,.76-2.92,0-4.23l-5.13-8.88c-.76-1.31-2.15-2.11-3.66-2.11Z"
						})
					] })
				})
			}),
			/* @__PURE__ */ _jsx("g", {
				id: "Impact_Thick",
				children: /* @__PURE__ */ _jsx("g", {
					className: "impact-cls-22",
					children: /* @__PURE__ */ _jsxs("g", { children: [
						/* @__PURE__ */ _jsx("path", {
							className: "impact-cls-17",
							d: "M397.57,4.89h-36.23c-4.67,0-8.98,2.49-11.31,6.53l-18.12,31.38c-2.33,4.04-2.33,9.02,0,13.07l18.12,31.38c2.33,4.04,6.65,6.53,11.31,6.53h36.23c4.67,0,8.98-2.49,11.31-6.53l18.12-31.38c2.33-4.04,2.33-9.02,0-13.07l-18.12-31.38c-2.33-4.04-6.65-6.53-11.31-6.53Z"
						}),
						/* @__PURE__ */ _jsx("path", {
							className: "impact-cls-9",
							d: "M391.79,15.23h-24.3c-4.67,0-8.98,2.49-11.31,6.53l-12.15,21.04c-2.33,4.04-2.33,9.02,0,13.07l12.15,21.04c2.33,4.04,6.65,6.53,11.31,6.53h24.3c4.67,0,8.98-2.49,11.31-6.53l12.15-21.04c2.33-4.04,2.33-9.02,0-13.07l-12.15-21.04c-2.33-4.04-6.65-6.53-11.31-6.53Z"
						}),
						/* @__PURE__ */ _jsx("path", {
							className: "impact-cls-7",
							d: "M385.79,25.25h-12.3c-4.67,0-8.98,2.49-11.31,6.53l-6.15,10.65c-2.33,4.04-2.33,9.02,0,13.07l6.15,10.65c2.33,4.04,6.65,6.53,11.31,6.53h12.3c4.67,0,8.98-2.49,11.31-6.53l6.15-10.65c2.33-4.04,2.33-9.02,0-13.07l-6.15-10.65c-2.33-4.04-6.65-6.53-11.31-6.53Z"
						}),
						/* @__PURE__ */ _jsx("path", {
							className: "impact-cls-16",
							d: "M384.85,35.8h-10.32c-1.51,0-2.91,.81-3.66,2.11l-5.16,8.93c-.76,1.31-.76,2.92,0,4.23l5.16,8.93c.76,1.31,2.15,2.11,3.66,2.11h10.32c1.51,0,2.91-.81,3.66-2.11l5.16-8.93c.76-1.31,.76-2.92,0-4.23l-5.16-8.93c-.76-1.31-2.15-2.11-3.66-2.11Z"
						})
					] })
				})
			})
		] })]
	})]
});
const ForwardRef = forwardRef(SvgImpactDrkBluFullcolorIcon);
export { ForwardRef as ReactComponent };
